import type { ClassroomStudent } from "classroom/types";
import type { ClassroomStudentResource } from "api/generated";

export const classroomStudentFromDto = (
  resource: ClassroomStudentResource,
): ClassroomStudent => ({
  id: resource.id,
  name: resource.name,
  avatar: resource.avatar,
  mentor_class: resource.mentor_class,
  mentors: resource.mentors,
});
